import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';
import { COLORS } from '@nzassa/shared';

export function BrandFooter() {
  const { t } = useTranslation();

  return (
    <footer style={{ background: COLORS.blue }} className="text-white">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="grid gap-8 sm:grid-cols-3">
          {/* Brand */}
          <div>
            <img src="/logos/nzassalearn-mono-white.svg" alt="NzassaLearn" className="h-8 mb-3" loading="lazy" />
            <p className="text-sm text-white/60 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-white/80 mb-3">{t('footer.programme')}</h4>
            <ul className="space-y-2 text-sm text-white/50">
              <li><a href="#features" className="hover:text-white/80 transition-colors">{t('footer.fonctionnalites')}</a></li>
              <li><a href="#parcours" className="hover:text-white/80 transition-colors">{t('footer.le_parcours')}</a></li>
              <li><a href="/a-propos" className="hover:text-white/80 transition-colors">{t('footer.a_propos')}</a></li>
              <li><a href="/connexion" className="hover:text-white/80 transition-colors">{t('common.connexion')}</a></li>
            </ul>
          </div>

          {/* Institutional */}
          <div>
            <h4 className="text-sm font-semibold text-white/80 mb-3">{t('footer.institutionnel')}</h4>
            <div className="flex items-center gap-2 mb-3">
              <img src="/logos/ansut.svg" alt="ANSUT" className="h-6 brightness-0 invert opacity-60" loading="lazy" />
            </div>
            <div className="flex items-center gap-1.5 text-xs text-white/40">
              <Shield className="h-3.5 w-3.5" />
              <span>{t('footer.donnees_protegees')}</span>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs text-white/30">
            {t('footer.droits_reserves', { year: new Date().getFullYear() })}
          </div>
          <div className="text-xs text-white/30">
            {t('footer.propulse_par')}
          </div>
        </div>
      </div>
    </footer>
  );
}
